import { Menu, Transition } from '@headlessui/react'
import { Fragment, ReactNode } from 'react'

export default function MonitorActionMenu({ options, children, className }: { options: any, children: ReactNode, className: string }) {

  return (
    <div className="">
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <Menu.Button className={className}>
          {children}
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 w-30 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-xl ring-2 ring-black ring-opacity-5 focus:outline-none z-10 box-content">
            <div className="px-1 py-2 ">  
              <div>
              {options.map((option:ReactNode) =>{
                return <Menu.Item>
                {option}
              </Menu.Item>
              })}
              </div>
            </div>
          </Menu.Items> 
        </Transition>
      </Menu>
    </div>
  )
}